import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {useIntl} from 'react-intl'
import {useAuth} from '../../modules/auth'
import {getUserByToken} from '../../modules/auth/core/_requests'
import {useLang} from '../../../_metronic/i18n/Metronici18n'

const API_URL_REAL = process.env.REACT_APP_API_URL

interface PlacementResult {
  code: string
  program: string
  obysStudentNumber: string
  obysPassword: string
  preferencePeriodName: string
  preferencePeriodNameEn: string
  message: string
  name: string
}

const PlacementPage = (): React.ReactElement | null => {
  const [placementResult, setPlacementResult] = useState<PlacementResult | null>(null)
  const [loading, setLoading] = useState(true)
  // const { currentUser } = useAuth()

  const intl = useIntl()
  const [currentUser, setCurrentUser] = useState<any | undefined>()
  const lang = useLang()

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const {data} = await getUserByToken()
        if (data && data.email !== undefined && data.email !== '') {
          setCurrentUser(data)
          //console.log(data)
        }
      } catch (error) {
        console.error('Error fetching user data:', error)
      }
    }
    fetchUserData()

    axios
      .get<PlacementResult>(`${API_URL_REAL}/Custom/GetPlacementResult`)
      .then((response) => {
        setPlacementResult(response.data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return <p>Loading...</p>
  }

  if (placementResult?.code === '2') {
    return (
      <div className='alert alert-danger'>{intl.formatMessage({id: placementResult?.message})}</div>
    )
  }

  if (!placementResult) {
    return (
      <div className='alert alert-danger'>
        {intl.formatMessage({id: 'There is a problem with your request. Please try again later.'})}
      </div>
    )
  }

  if (currentUser && currentUser?.placementSituation === 'Yerleştirme Yok') {
    return (
      <div className='alert alert-danger'>{intl.formatMessage({id: 'TercihteBulunmadiniz'})}</div>
    )
  }

  if (currentUser && currentUser?.placementSituation === 'Değerlendirme Aşamasında') {
    return (
      <div className='alert alert-danger'>
        {intl.formatMessage({id: 'TercihlerinizDegerlendiriliyor'})}
      </div>
    )
  }

  if (currentUser && currentUser?.placementSituation === 'Reddedildi') {
    return (
      <div className='alert alert-danger'>
        {intl.formatMessage({id: 'You are not placed in any program.'})}
      </div>
    )
  }

  return (
    <div>
      <h1>
        {intl.formatMessage({id: 'Dear'})} {placementResult?.name}
      </h1>
      <h2>
        {intl.formatMessage({id: 'Placement Results for'})}:{' '}
        {lang === 'tr'
          ? placementResult?.preferencePeriodName
          : placementResult?.preferencePeriodNameEn}{' '}
      </h2>

      <div className='card mb-3'>
        <div className='card-body'>
          <h5 className='card-title'>
            {intl.formatMessage({id: 'You have been placed in the program'})}:{' '}
            {placementResult?.program}
          </h5>
          <p className='card-text mt-5'>
            <strong>{intl.formatMessage({id: 'OBYS Student Number'})}:</strong>{' '}
            {placementResult?.obysStudentNumber}
          </p>
          {/* <p className="card-text">
                        <strong>{intl.formatMessage({ id: 'OBYS Password' })}:</strong> {placementResult?.obysPassword}
                    </p> */}
        </div>
      </div>

      <div className='alert alert-info'>
        {intl.formatMessage({id: 'Note'})}:{' '}
        {intl.formatMessage({
          id: 'Use the OBYS Student Number and OBYS Password provided above for your initial registration.',
        })}
      </div>
    </div>
  )
}

export default PlacementPage
